import React from 'react';
import EcheanceList from '../../Molecules/MoleculeContract/EcheanceList';
import BeneficiaryList from '../../Molecules/MoleculeContract/BeneficiaryList';
import DocList from '../../Molecules/MoleculeContract/DocsList';

const ContractDetails = ({ contract, user, activeMenu }) => {
  return (
    <div className="contract-details">
      {activeMenu === 'echeancier' && <EcheanceList contract={contract} />}
      {activeMenu === 'beneficiaires' && (
        <BeneficiaryList contract={contract} user={user} />
      )}
      {activeMenu === 'documents' && <DocList contract={contract} />}
      {activeMenu === 'mes_garanties' && (
        <DocList contract={contract} isGarantie={true} />
      )}
    </div>
  );
};

export default ContractDetails;
